import axios from "axios";
import APIURL from "../common/Config";
import { encodeRequestData, decodeResponseData } from "./apiSecurity";


export const sendOtp = async (phoneNumber) => {
  const data = {
    requestType: "SEND-OTP",
    msisdn: phoneNumber,
    otpPin: "",
    otpSessionId: "",
    userCatg: "",
    userId: "",
    emailId: "",
    name: "",
    lattitude: "",
    longitude: "",
    timeStamp: new Date().toISOString(),
    reqTime: new Date().toISOString(),
  };

  const payload = encodeRequestData(data);

  const response = await axios.post(`${APIURL}/otp/service`, payload);
  return decodeResponseData(response.data);
};


export const validateOtp = async (phoneNumber, otp, sessionId) => {
  const data = {
    requestType: "VALIDATE-OTP",
    msisdn: phoneNumber,
    otpPin: otp,
    otpSessionId: sessionId,
    userCatg: "",
    userId: "",
    emailId: "",
    name: "",
    lattitude: "",
    longitude: "",
    timeStamp: new Date().toISOString(),
    reqTime: new Date().toISOString(),
  };

  const payload = encodeRequestData(data);

  const response = await axios.post(`${APIURL}/otp/service`, payload);
  return decodeResponseData(response.data);
};
